<div class="mobile-wizard">
  <div class="mobile-wizard__stepper">
    <app-stepper
      (selectionChange)="onStepperChange($event)"
      [selectedIndex]="currentStepIndex"
    >
      <cdk-step
        [editable]="!wasSuccessful"
        [completed]="wasSuccessful"
        [label]="'searchSubscription.stepper_title.mobile.step1' | i18n"
      >
        <div class="step">
          <div class="step__main">
            <app-mobile-step-one></app-mobile-step-one>
          </div>
          <div class="step__footer step__footer--mobile">
            <button class="mdc-button" cdkStepperNext>
              <span class="mdc-button__ripple"></span>
              <span class="mdc-button__label">
                {{ 'common.continue' | i18n }}
              </span>
              <span class="mdc-button__touch"></span>
            </button>
          </div>
        </div>
      </cdk-step>

      <cdk-step
        [editable]="!wasSuccessful"
        [completed]="wasSuccessful"
        [label]="
          (wasSuccessful
            ? 'searchSubscription.stepper_title.mobile.step_final'
            : 'searchSubscription.stepper_title.mobile.step2'
          ) | i18n
        "
      >
        <div class="step">
          <div class="step__main">
            <app-mobile-step-two
              (requestPreviousStep)="goToPreviousStep()"
            ></app-mobile-step-two>
          </div>

          <div class="step__footer step__footer--mobile">
            <button
              class="mdc-button"
              [disabled]="!canSubmit"
              (click)="submit()"
            >
              <span class="mdc-button__ripple"></span>
              <span class="mdc-button__label">
                {{ 'searchSubscription.save' | i18n }}
              </span>
              <span class="mdc-button__touch"></span>
            </button>
          </div>
        </div>
      </cdk-step>
    </app-stepper>
  </div>

  <button class="mobile-wizard__close-button" (click)="closeMobile()">
    <i class="material-icon"> close </i>
  </button>

  <div class="mobile-wizard__success-message" *ngIf="wasSuccessful">
    <lib-success-message>
      <a class="mdc-button success-message__button" [href]="objectSearchUrl">
        <span class="mdc-button__ripple"></span>
        <span class="mdc-button__label">
          {{ 'searchSubscription.toObjectSearch' | i18n }}
        </span>
        <span class="mdc-button__touch"></span>
      </a>
    </lib-success-message>
  </div>
</div>
